import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import * as SwitchPrimitive from "@radix-ui/react-switch";
import { tv } from "tailwind-variants";
import cn from "../../utils/cn";
const switchRootVariants = tv({
    base: "relative inline-flex rounded-xl border border-transparent transition-colors duration-200 focus-visible:outline-none",
    variants: {
        size: {
            sm: "h-auto w-7",
            md: "h-auto w-9",
        },
        disabled: {
            true: "cursor-not-allowed",
            false: "cursor-pointer",
        },
        checked: {
            true: "bg-primary-9",
            false: "bg-gray-9",
        },
    },
    compoundVariants: [
        {
            checked: true,
            disabled: true,
            className: "bg-primary-7",
        },
        {
            checked: false,
            disabled: true,
            className: "bg-gray-7",
        },
    ],
});
const switchThumbVariants = tv({
    base: "flex transform rounded-full bg-white transition duration-200",
    variants: {
        size: {
            sm: "size-3.5",
            md: "size-5",
        },
        disabled: {
            true: "cursor-not-allowed",
            false: "cursor-pointer",
        },
        checked: {
            true: "translate-x-3.5",
            false: "translate-x-0",
        },
    },
    compoundVariants: [
        {
            size: "md",
            checked: true,
            className: "translate-x-3.5",
        },
        {
            size: "sm",
            checked: true,
            className: "translate-x-3",
        },
    ],
});
const Switch = React.forwardRef(({ size = "md", disabled = false, className, ...props }, ref) => {
    return (_jsx(SwitchPrimitive.Root, { "data-testid": "switch", className: cn(switchRootVariants({
            size,
            disabled,
            checked: props.checked,
        }), className), ...props, children: _jsx(SwitchPrimitive.Thumb, { ref: ref, className: cn(switchThumbVariants({
                size,
                disabled,
                checked: props.checked,
            })) }) }));
});
Switch.displayName = SwitchPrimitive.Root.displayName;
export default Switch;
